module.exports = __webpack_public_path__ + "static/media/rsrcmtr_132.ae2df772.ico";